import { h } from "preact";
import { Check, QuantityPlus } from "../../helpers/icons";
import QuantityInput from "../../global/quantity-input/quantity-input-react";

export default function SwatchDetailsChip({
  item,
  radioName,
  quantity,
  limitEach,
  canAddMore,
  onSelect,
  onToggle,
  onQuantityChange,
}) {
  const strings = window.localeStrings.swatch_details;
  const inBasket = quantity > 0;
  const atLimit = !inBasket && !canAddMore;
  // Trade customers get a stepper, but only once there's a quantity to step —
  // an empty one is a wider target saying the same thing as the plus.
  const showStepper = limitEach > 1 && inBasket;

  return (
    <div className="swatch-details-drawer__chip">
      <div className="swatch-details-drawer__chip-frame">
        <label className="swatch-details-drawer__chip-tile">
          <input
            type="radio"
            className="swatch-details-drawer__chip-input"
            name={radioName}
            value={item.optionValueName}
            checked={item.selected}
            onChange={() => onSelect(item.optionValueName)}
          />
          <span className="swatch-details-drawer__chip-tile-inner">
            {item.image && (
              <img
                className="swatch-details-drawer__chip-image"
                src={window.getSizedImageUrl(item.image.url, "400x")}
                alt=""
                loading="lazy"
              />
            )}
          </span>
          <span className="visually-hidden">{item.optionValueName}</span>
        </label>
        {item.swatchProduct &&
          (showStepper ? (
            <QuantityInput
              className="swatch-details-drawer__chip-quantity"
              quantity={quantity}
              setQuantity={onQuantityChange}
              max={limitEach}
            />
          ) : (
            <button
              type="button"
              className={`swatch-details-drawer__chip-add ${
                inBasket ? "swatch-details-drawer__chip-add--added" : ""
              } ${atLimit ? "swatch-details-drawer__chip-add--at-limit" : ""}`}
              // Not the native disabled attribute: the cap is explained in the
              // footer, and a disabled button is unreachable by keyboard.
              aria-disabled={atLimit ? "true" : undefined}
              aria-pressed={inBasket}
              onClick={() => onToggle()}
            >
              <span className="visually-hidden">
                {(inBasket
                  ? strings.remove_swatch
                  : strings.add_swatch
                ).replace("[name]", item.optionValueName)}
              </span>
              {inBasket ? <Check /> : <QuantityPlus />}
            </button>
          ))}
      </div>
      <span className="swatch-details-drawer__chip-label" aria-hidden="true">
        {item.optionValueName}
      </span>
    </div>
  );
}
